import { ViewStyle } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { getVariableValue } from 'tamagui';

export const useSheetContainerStyles = (topMargin?: boolean): ViewStyle => {
  const { bottom: safeAreaBottom } = useSafeAreaInsets();
  const padding3 = getVariableValue('$3', 'space');

  return {
    paddingBottom: safeAreaBottom,
    paddingHorizontal: padding3,
    marginTop: topMargin ? padding3 : 0
  };
};
